import { debounce } from 'lodash';
import { isEmpty } from 'lodash-es';
import { useEffect, useState, useRef, useMemo } from 'react';
import { ICandidate, getCandidateDetailsForGDPR } from 'wisestep-api';

const useCheckExistingCandidate = (socialLinks: string[], candidate?: ICandidate | null) => {
  const [openMergeCandidate, setOpenMergeCandidate] = useState(false);
  const [existingCandidate, setExistingCandidate] = useState<ICandidate | null>(null);
  const [newSocialLink, setNewSocialLink] = useState<string | null>(null);
  const prevSocialLinksRef = useRef(new Set<string>());

  const checkCandidate = useMemo(
    () =>
      debounce(async (newSocialUrl: string) => {
        if (isEmpty(newSocialUrl)) return;
        const response = await getCandidateDetailsForGDPR(
          newSocialUrl,
          candidate?.workspaceId ?? ''
        );
        const foundCandidate = response?.data;

        if (foundCandidate && candidate && candidate?.candidateId !== foundCandidate?.candidateId) {
          setOpenMergeCandidate(true);
          setExistingCandidate(foundCandidate);
          setNewSocialLink(newSocialUrl);
        }
      }, 300),
    [candidate]
  );

  useEffect(() => {
    if (!candidate || !socialLinks?.length) return;

    const profileURLsSet = new Set((candidate.profileURLs as string[]) || []);
    const prevSocialLinks = prevSocialLinksRef.current;

    const newLinks = socialLinks.filter(
      (url) => !prevSocialLinks.has(url) && !profileURLsSet.has(url)
    );

    if (newLinks.length > 0) {
      checkCandidate(newLinks[0]);
    }

    prevSocialLinksRef.current = new Set(socialLinks);
  }, [socialLinks, candidate, checkCandidate]);

  return { openMergeCandidate, setOpenMergeCandidate, existingCandidate, newSocialLink };
};

export default useCheckExistingCandidate;
